<app-fn-ui-navigation-tree [treeConfig]="treeConfig"
                           [treeModel]="navigationTree.nodes"
                           [selectedNode]="selectedNode">
</app-fn-ui-navigation-tree>
